import { toast } from "react-toastify";

import { ApiService } from "../../../config";
import { handleToken } from "../../../utils/expiredTokenLogout";
import { handleError } from "../../../utils/parseApiReturn";
import type { VisaoGeral } from "../types";

const getVisaoGeral = async (token: string, uf?: string | null): Promise<VisaoGeral | null> => {
  try {
    const result = await ApiService.get("/admin/overview", {
      headers: { Authorization: `Bearer ${token}` },
      params: uf ? { uf } : undefined,
    });
    const { data, error } = result.data;
    if (error) {
      handleToken(result.data.message);
      toast.error(handleError(error, "Erro ao carregar o painel.").message);
      return null;
    }
    return data ?? null;
  } catch (error) {
    toast.error(handleError(error, "Erro ao carregar o painel.").message);
    return null;
  }
};

export const adminOverviewService = { getVisaoGeral };
